import { render } from "./AgentConfiguration.vue?vue&type=template&id=50a83e6f&scoped=true"
import script from "./AgentConfiguration.vue?vue&type=script&lang=js"
export * from "./AgentConfiguration.vue?vue&type=script&lang=js"

import "./AgentConfiguration.vue?vue&type=style&index=0&id=50a83e6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a83e6f"]])

export default __exports__